/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import DefaultLayout from "../../components/DefaultLayout";
import { showNotification } from "../../utils/error";
import axiosInstance from "../../utils/axiosInstance";
import ManageWalletsTable from "../../components/Tables/ManageWalletsTable";
const baseUrl = process.env?.REACT_APP_BASE_URL;

const ManageWallets = () => {
  const theads = [
  { name: "ID", width: "40%" },
  { name: "Email Address", width: "40%" },
  { name: "Created At", width: "20%" }
];
  const [allWallets, setAllWallets] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20); // Number of items to display per page
  const [searchTerm, setSearchTerm] = useState("");
  const [totalCount, setTotalCount] = useState(0);

  const getAllWallets = async () => {
    setIsFetching(true);
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/wallet/fetch-all?size=${itemsPerPage}&offset=${(currentPage - 1) * itemsPerPage}`
      );

      if (response?.data?.success) {
        setAllWallets([...response?.data?.data]);
        setTotalCount(response?.data?.totalCount);
        setTimeout(() => {
          setIsFetching(false);
        }, 1000);
      } else {
        setTimeout(() => {
          setIsFetching(false);
        }, 1000);
      }
    } catch (error) {
      setTimeout(() => {
        setIsFetching(false);
      }, 1000);

      showNotification("error", error.message);
    }
  };

  // Fetch only subscribed wallets
  const getSubscribedWallets = async () => {
    setIsFetching(true);
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/wallet/fetch-all?size=${itemsPerPage}&offset=${(currentPage - 1) * itemsPerPage}&isSubscribed=true`
      );
      if (response?.data?.success) {
        setAllWallets([...response?.data?.data]);
        setTotalCount(response?.data?.totalCount);
        setTimeout(() => {
          setIsFetching(false);
        }, 1000);
      } else {
        setTimeout(() => {
          setIsFetching(false);
        }, 1000);
      }
    } catch (error) {
      setTimeout(() => {
        setIsFetching(false);
      }, 1000);
      showNotification("error", error.message);
    }
  };

  // Fetch only unsubscribed wallets
  const getUnsubscribedWallets = async () => {
    setIsFetching(true);
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/wallet/fetch-all?size=${itemsPerPage}&offset=${(currentPage - 1) * itemsPerPage}&isSubscribed=false`
      );
      if (response?.data?.success) {
        setAllWallets([...response?.data?.data]);
        setTotalCount(response?.data?.totalCount);
        setTimeout(() => {
          setIsFetching(false);
        }, 1000);
      } else {
        setTimeout(() => {
          setIsFetching(false);
        }, 1000);
      }
    } catch (error) {
      setTimeout(() => {
        setIsFetching(false);
      }, 1000);
      showNotification("error", error.message);
    }
  };

  useEffect(() => {
    getAllWallets();
  }, [itemsPerPage, currentPage]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleItemsPerPageChange = (data) => {
    if (totalCount === 1) {
      return;
    }
    if (data === "See All") {
      setItemsPerPage(totalCount);
      setCurrentPage(1);
    } else {
      setItemsPerPage(data);
      setCurrentPage(1);
    }
  };
  const nextPage = () => {
    if (currentPage < Math.ceil(totalCount / itemsPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };

  // Go to previous page
  const prevPage = () => {
    if (itemsPerPage === totalCount || allWallets?.length === totalCount) {
      return;
    }
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const [typingTimeout, setTypingTimeout] = useState(0);

  const handleSearchChange = (event) => {
    setIsFetching(true);
    const userInput = event.target.value;
    setSearchTerm(event.target.value);

    clearTimeout(typingTimeout);

    const timeout = setTimeout(() => {
      searchApi(userInput);
    }, 1000);

    // Save the timeout ID
    setTypingTimeout(timeout);
  };

  const searchApi = async (query) => {
    try {
      const response = await axiosInstance.get(
        baseUrl +
          "/wallet/fetch-all/details" +
          `?size=${itemsPerPage}&offset=${
            itemsPerPage === totalCount ? 0 : currentPage - 1
          }&userList=true&search=${query}`
      );
      setAllWallets(response.data?.data);
      setTotalCount(response?.data?.totalCount);
      setTimeout(() => {
        setIsFetching(false);
      }, 1000);
    } catch (error) {
      setTimeout(() => {
        setIsFetching(false);
      }, 1000);
      showNotification("error", error?.message);
    }
  };
  // useEffect(() => {
  //   if (searchTerm) {
  //     const filteredItems = allWallets?.filter((item) =>
  //       item.id.toLowerCase().includes(searchTerm.toLowerCase())
  //     );
  //     setAllWallets(filteredItems);
  //   } else {
  //     setAllWallets(allData);
  //   }
  // }, [searchTerm]);
  return (
    <>
      <DefaultLayout
        setSearchTerm={setSearchTerm}
        handleSearchChange={handleSearchChange}
        searchTerm={searchTerm}
        getAllWallets={getAllWallets}>
        <ManageWalletsTable
          theads={theads}
          allWallets={allWallets}
          prevPage={prevPage}
          nextPage={nextPage}
          paginate={paginate}
          currentPage={currentPage}
          indexOfFirstItem={indexOfFirstItem}
          indexOfLastItem={indexOfLastItem}
          itemsPerPage={itemsPerPage}
          isFetching={isFetching}
          totalCount={totalCount}
          handleItemsPerPageChange={handleItemsPerPageChange}
          getAllWallets={getAllWallets}
          getSubscribedWallets={getSubscribedWallets}
          getUnsubscribedWallets={getUnsubscribedWallets}
        />
      </DefaultLayout>
    </>
  );
};

export default ManageWallets;
